import React from 'react';
import SuiviHeader from '../../../composants/SuiviHeader/SuiviHeader';
import { getStatusColor } from '../../../utils/entityUtils';
import { OperationBC } from '../types';

interface OperationHeaderProps {
  operation: OperationBC;
  backgroundImage?: string;
  onRetour?: () => void;
}

// Banniere acheteur-BC : delegue au generique SuiviHeader (meme composant que le MS), config
// source="BC". SuiviHeader gere en interne l'expiration, le libelle "A relancer" (statut 12)
// et le chrono. Le libelle/couleur du statut viennent du nom + getStatusColor.
const OperationHeader: React.FC<OperationHeaderProps> = ({ operation, backgroundImage, onRetour }) => (
  <SuiviHeader
    titre={operation.nom || ''}
    sousTitre={''}
    // Parite MS : le nom de l'ouvrage devient le titre principal (h1) et le nom de l'operation passe
    // en sous-ligne. Suit le buffer d'edition live comme le MS (OperationHeaderBanner), sinon la
    // valeur persistee — sans ca le titre ne bougeait qu'apres enregistrement.
    nomOuvrage={operation.formulaire?.nomOuvrage || operation.nom_ouvrage || undefined}
    subtitle={`${operation.lot_technique?.id ?? ''} - ${operation.lot_technique?.nom ?? ''}, ${operation.id_lot_departement ?? ''} - ${operation.lot_departement?.departement?.nom ?? ''}`}
    status={operation.status?.nom || 'Statut inconnu'}
    statusColor={getStatusColor(operation.status?.nom || '')}
    delais={operation.expire_at}
    backgroundImage={backgroundImage}
    source="BC"
    statusId={operation.status?.id}
    onRetour={onRetour}
    encart={{
      operationId: operation.id,
      numeroMarche: String(operation.numero ?? ''),
      // Sensibilite affichee comme cote MS. Valeur persistee (et non le buffer) : c'est celle qui
      // engage le document.
      sensibilite: operation.niveau_sensibilite || null,
    }}
  />
);

export default OperationHeader;
